export var BackupPolicyType;
(function (BackupPolicyType) {
    BackupPolicyType["BACKUP_POLICY_TYPE_UNSPECIFIED"] = "UNSPECIFIED";
    BackupPolicyType["BACKUP_POLICY_TYPE_STANDARD"] = "STANDARD";
    BackupPolicyType["BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD"] = "AWS_NATIVE_STANDARD";
    BackupPolicyType["BACKUP_POLICY_TYPE_HIGH_FREQUENCY"] = "HIGH_FREQUENCY";
    BackupPolicyType["BACKUP_POLICY_TYPE_PITR"] = "PITR";
    BackupPolicyType["BACKUP_POLICY_TYPE_AWS_NATIVE_PITR"] = "AWS_NATIVE_PITR";
    BackupPolicyType["BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR"] = "BIGQUERY_NATIVE_PITR";
    BackupPolicyType["BACKUP_POLICY_TYPE_AZURE_FILES"] = "AZURE_FILES_STANDARD";
    BackupPolicyType["BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR"] = "AZURE_SQL_DATABASE_NATIVE_PITR";
    BackupPolicyType["BACKUP_POLICY_TYPE_GOOGLE_WORKSPACE"] = "GOOGLE_WORKSPACE";
    BackupPolicyType["BACKUP_POLICY_TYPE_MICROSOFT_365"] = "MICROSOFT_365";
    BackupPolicyType["BACKUP_POLICY_TYPE_AZURE_ENTRA_ID"] = "AZURE_ENTRA_ID";
})(BackupPolicyType || (BackupPolicyType = {}));
